import { Media } from './media'
import { StripePrice } from './stripe'
import { PartialUser } from './user'

/**
 * A trainer has one program by default, but could have many.
 * Each post is associated with a program, which provides access control,
 * pricing information, and tracks leaderboard data.
 */
export interface Program {
  id: string
  leaderboard?: LeaderboardRecord
  trainer: PartialUser
  title: string
  description: string
  prices: ProgramPrice[]
  cover?: Media
  bio?: string
  sponsors?: string[]
  type?: ProgramType
  tags?: ProgramTags
  actions?: string[]
}

/**
 * Program price including explicit price values
 */
export interface ProgramPrice extends StoredProgramPrice {
  base: number
  charge: number
  fee: number
  payout: number
}

/**
 * Program price as it is stored in the database
 */
export interface StoredProgramPrice {
  description: string
  id: string
  title: string
  original: StripePrice
}

/**
 * Records the number of sessions completed in this program for a given user
 */
export interface LeaderboardRecord {
  user: PartialUser
  sessionsCompleted: number
}

export interface ProgramTags {
  audience: string[]
  goals: string[]
  specifics: string[]
  equipment: string[]
  programDuration: string[]
  sessionDuration: string[]
}
export enum ProgramType {
  GROUP = 'group',
  PROGRAM = 'program',
}
